/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const a = {};
function r(c, o, e) {
  a[c] = { value: o, hsva: e };
}
function t(c, o, e) {
  a[c] = { value: o, rgba: e };
}
function n(c, o, e) {
  a[c] = { value: o, hex: e };
}
function h(c) {
  delete a[c];
}
function i(c, o) {
  if (c) {
    const e = a[c];
    return e && e.value === o ? e.hex : void 0;
  }
}
function u(c, o) {
  if (c) {
    const e = a[c];
    return e && e.value === o ? e.hsva : void 0;
  }
}
function v(c, o) {
  if (c) {
    const e = a[c];
    return e && e.value === o ? e.rgba : void 0;
  }
}
export {
  n as cacheHex,
  r as cacheHsva,
  t as cacheRgba,
  i as getCachedHex,
  u as getCachedHsva,
  v as getCachedRgba,
  h as removeCachedColor
};
